import * as React from 'react'
import * as titleize from 'titleize'

import SearchLink from '../../../containers/searchLinkContainer'

import * as styles from './breadcrumb.module.css'

interface IProps {
  parsedLocation: any
  categories: any
}

const formatCategoryDisplayName = (categoryName: string, categories: any) => {
  if (categories && categories.length) {
    return categories.reduce(
      (result: string, category: any) =>
        category.key.split('/').pop() === categoryName ? category.name : result,
      ''
    )
  }

  return titleize(categoryName.replace('-', ' '))
}

const Separator = () => <span className={styles.separator}>/</span>

const CategoryBreadcumb = ({ parsedLocation, categories }: IProps) => {
  const selectedCategory = parsedLocation.category
  if (!selectedCategory) {
    return null
  }

  const rootQuery = { ...parsedLocation }
  delete rootQuery.category

  const chosenOptionArray = selectedCategory.split('/')
  const chosenOptionLength = chosenOptionArray.length

  const BreadLinks = chosenOptionArray.map((option: string, index: number) => {
    const newQuery = {
      ...parsedLocation,
      category: selectedCategory.substring(
        0,
        selectedCategory.indexOf(chosenOptionArray[index]) +
          chosenOptionArray[index].length
      )
    }
    delete newQuery.page

    if (index === chosenOptionLength - 1) {
      return (
        <li
          property="itemListElement"
          typeof="ListItem"
          key={index}
          className={styles.list}
        >
          <span property="name" className={styles.name}>
            {formatCategoryDisplayName(chosenOptionArray[index], categories)}
          </span>
          <meta property="position" content={`${index + 2}`} />
        </li>
      )
    } else {
      const separatorKey = `separator-${index}`
      return [
        <li
          property="itemListElement"
          typeof="ListItem"
          key={index}
          className={styles.list}
        >
          <SearchLink
            property="item"
            typeof="WebPage"
            className={styles.link}
            locationParams={newQuery}
          >
            <span property="name">
              {formatCategoryDisplayName(chosenOptionArray[index], categories)}
            </span>
          </SearchLink>
          <meta property="position" content={`${index + 2}`} />
        </li>,
        <Separator key={separatorKey} />
      ]
    }
  })

  return (
    <ol
      vocab="http://schema.org/"
      typeof="BreadcrumbList"
      className={styles.root}
    >
      <li
        key="all"
        property="itemListElement"
        typeof="ListItem"
        className={styles.list}
      >
        <SearchLink
          property="item"
          typeof="WebPage"
          className={styles.link}
          locationParams={rootQuery}
        >
          <span property="name">All Categories</span>
        </SearchLink>
        <meta property="position" content="1" />
      </li>
      <Separator />
      {BreadLinks}
    </ol>
  )
}

export default CategoryBreadcumb
